namespace RioERP.Enquiry {
    export interface EnquiryForm {
        EnquiryName: Serenity.StringEditor;
        EEnquiryMode: Serenity.EnumEditor;
        EnquiryType: Serenity.EnumEditor;
        CustomerId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
        SubjectId: Serenity.LookupEditor;
        NopEnquiryId: Serenity.IntegerEditor;
        Mobile1: Serenity.StringEditor;
        EmailId1: Serenity.EmailEditor;
        EStatus: Serenity.EnumEditor;
        EnquiryDate: Serenity.DateEditor;
        FollowupDate: Serenity.DateEditor;
        FollowUpTime: FollowUpTimeEditor;
        EnquiryProducts: Serenity.LookupEditor;
        HandledBy: Serenity.LookupEditor;
        Address1: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Pincode: Serenity.IntegerEditor;
        Country: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        EnquiryFollowUp: EnquiryFollowupEditor;
    }

    export class EnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.Enquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EnquiryForm.init)  {
                EnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.EmailEditor;
                var w5 = s.DateEditor;
                var w6 = FollowUpTimeEditor;
                var w7 = s.TextAreaEditor;
                var w8 = EnquiryFollowupEditor;

                Q.initFormType(EnquiryForm, [
                    'EnquiryName', w0,
                    'EEnquiryMode', w1,
                    'EnquiryType', w1,
                    'CustomerId', w2,
                    'CategoryId', w2,
                    'SubjectId', w2,
                    'NopEnquiryId', w3,
                    'Mobile1', w0,
                    'EmailId1', w4,
                    'EStatus', w1,
                    'EnquiryDate', w5,
                    'FollowupDate', w5,
                    'FollowUpTime', w6,
                    'EnquiryProducts', w2,
                    'HandledBy', w2,
                    'Address1', w0,
                    'City', w0,
                    'StateId', w2,
                    'Pincode', w3,
                    'Country', w0,
                    'Note', w7,
                    'EnquiryFollowUp', w8
                ]);
            }
        }
    }
}
